<template>
  <div ref="main" class="t-captcha-modal"></div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false // 是否已经显示了弹窗
    }
  },
  methods: {
    show(captchaInitOpts) {
      const initNECaptchaWithFallback = window.initNECaptchaWithFallback
      if (!initNECaptchaWithFallback) {
        alert('initNECaptchaWithFallback初始化错误')
        return Promise.reject(new Error('initNECaptchaWithFallback初始化错误'))
      }

      if (this.isShow) {
        return Promise.reject(new Error('已经显示了弹窗'))
      }

      this.isShow = true

      return new Promise((resolve, reject) => {
        initNECaptchaWithFallback(
          {
            // captchaId: '35d088eb746946f68ba82757fbbed714',
            mode: 'popup',
            width: '320px',
            element: '#app',
            enableClose: false,
            ...captchaInitOpts,
            onVerify: (err, data) => {
              console.log('onVerify', err)
              typeof captchaInitOpts.onVerify === 'function' && captchaInitOpts.onVerify(err, data)
              if (data) {
                resolve(data)
              }
            },
            onClose: () => {
              this.isShow = false
              typeof captchaInitOpts.onClose === 'function' && captchaInitOpts.onClose()
              reject(new Error('关闭了'))
            },
            onReady: () => {
              typeof captchaInitOpts.onReady === 'function' && captchaInitOpts.onReady()
            }
          },
          (instance) => {
            instance.popUp()
          },
          (err) => {
            console.error('初始化captcha失败', err)
            if (err && err.message) {
              alert(err && err.message)
            }
            reject(err)
          }
        )
      })
    }
  }
}
</script>

<style scoped>
.t-captcha-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  height: 300px;
  background-color: red;
  transform: translate(-50%, -50%);
}
</style>
